<ng-container *transloco="let convert;">
  <div class="wrapper">
    <div class="container">
      <div class="layout">
        <lib-manage-header
          (resetTenant)="resetTenantEvent($event)"
        ></lib-manage-header>
        <div class="banner-wrapper">
          @if (multiOfferActionSuccess) {
            <app-common-banner (close)="closeSuccessBanner()"
            [bannerConfig]="multiOfferActionSuccess"></app-common-banner>
          }
          @for (errorBanner of multiOfferActionErrors; track errorBanner; let index = $index) {
            <app-common-banner
            (close)="closeErrorBanner(index)" [bannerConfig]="errorBanner"></app-common-banner>
          }
        </div>
        <lib-active-vehicles-count [count]="count" [resultText]="displayText" role="alert"></lib-active-vehicles-count>

        <div class="layout__body">
          <div class="layout__sidebar">
            <lib-sidebar data-track-region="Manage Inventory Filters"></lib-sidebar>
          </div>

          <div class="layout__main-area" [style.overflow]="isMobileLayout ? 'visible' : 'auto'">
            <lib-utility-bar
              [isExporting]="isExporting"
              [showCreateDraftBulkSale]="isSellerBulkSaleFeature"
              [isSellReportingFeatureEnabled]="isSellReportingFeatureEnabled"
              [inServiceVehiclesEnabled]="isInServiceVehiclesEnabled"
              [singleListSelected]="singleListSelected"
              [disableSelectAll]="disableSelectAll"
              [isFilterByInServiceVehicles]="isFilterByInServiceVehicles"
              (exported)="onExport()"
              (mobileFilter)="mobileFilter = $event"
              #libBar
            ></lib-utility-bar>

            @if (singleListSelected) {
              <div class="mt-3">
                {{convert('sellModule.manageInventory.utilityBar.textMultiPurchaseNote')}}
              </div>
            }

            @if (!isSellerBulkSaleFeature || (searchStatusFilter$ | async) !== 'ACTIVE') {
              <ng-content *ngTemplateOutlet="cardListViewToggleButtons"></ng-content>
            }

            @if (sellSearchState$ | async; as sellSearchState) {
              <div
                id="layout-body"
                aria-hidden="false"
                class="mt-3"
                >
                @if (!(searchError$ | async)) {
                  @if (multiVinErrors$ | async; as multiVinErrors) {
                    @if (multiVinErrors.hasError && multiVinErrors.sellSearchState === 'loaded') {
                      <lib-multi-vin-error
                        [vins]="multiVinErrors.missingVins"
                        [stockNumbers]="multiVinErrors.missingStockNumbers"
                      ></lib-multi-vin-error>
                    }
                  }
                  @if (sellSearchState === 'loading') {
                    <lib-inventory-skeleton></lib-inventory-skeleton>
                    <lib-inventory-skeleton></lib-inventory-skeleton>
                    <lib-inventory-skeleton></lib-inventory-skeleton>
                  }
                  @if (sellSearchState === 'loaded' && vehicleList$ | async; as results) {
                    @if (showSearchTip) {
                      <p>{{showSearchTip}}</p>
                    }
                  }
                  @if ((searchResults$ | async)?.length === 0 && sellSearchState !== 'loading') {
                    <app-error-message
                      title="{{convert('sellModule.manageInventory.layout.textErrorTitle')}}"
                      subtitle="{{convert('sellModule.manageInventory.layout.textErrorSubTitle')}}"
                    ></app-error-message>
                  }
                  @if (sellSearchState === 'loaded' && vehicleList$ | async; as results) {
                    @if (results.length > 0 && isListView && vehicleCardCommon$ | async; as vehicleCardCommon) {
                      @if (!isMobileLayout) {
                        <div class="list-view-table-wrapper">
                          <table aria-label="Manage Inventory List View Table">
                            @if (!isVehicleFilterTypeISV) {
                              <thead>
                                <tr>
                                  <th id="Vehicle Header" class="ps-4 sticky-col first-col list-view-headers">{{convert('sellModule.manageInventory.listView.textVehicle')}}</th>
                                  <th id="Actions Header" class="sticky-col second-col list-view-headers" aria-hidden="true"></th>
                                  <th id="Shadow Header" class="shadow-col list-view-headers" aria-hidden="true"></th>
                                  <th id="Offers Header" class="col list-view-headers">{{convert('sellModule.manageInventory.listView.textOffers') | uppercase }}</th>
                                  <th id="Questions Header" class="col list-view-headers">{{convert('sellModule.manageInventory.listView.textQuestions') | uppercase}}</th>
                                  <th id="Status Header" class="col list-view-headers">{{convert('sellModule.manageInventory.listView.textStatus')}}</th>
                                  <th id="Highest Offer Header" class="col list-view-headers">{{convert('sellModule.manageInventory.listView.textHighestOffer')}}</th>
                                  <th id="Buy Now Header" class="col list-view-headers">{{convert('sellModule.manageInventory.listView.textBuyNow')}}</th>
                                  <th id="Opening Price Header" class="col list-view-headers"> {{convert('sellModule.manageInventory.listView.textOpeningPrice')}}</th>
                                  @if (showSaleFeeAndSalePriceColumn) {
                                    <th id="Sale Fee Header" class="col list-view-headers">{{convert('sellModule.manageInventory.listView.textSaleFee')}}</th>
                                  }
                                  @if (showSaleFeeAndSalePriceColumn) {
                                    <th id="Sale Price Header" class="col list-view-headers">{{convert('sellModule.manageInventory.listView.textSalePrice')}}</th>
                                  }
                                  @if (showTotalPriceColumn) {
                                    <th id="Total Price Header" class="col list-view-headers">{{convert('sellModule.manageInventory.listView.textTotalPrice')}}</th>
                                  }
                                  <th id="Shadow Header" class="shadow-col-end list-view-headers" aria-hidden="true"></th>
                                </tr>
                              </thead>
                            } @else {
                              <thead>
                                <tr>
                                  <th id="Vehicle Header" class="ps-4 sticky-col first-col list-view-headers">{{convert('sellModule.manageInventory.listView.textVehicle')}}</th>
                                  <th id="Actions Header" class="sticky-col second-col list-view-headers" aria-hidden="true"></th>
                                  <th id="Shadow Header" class="shadow-col list-view-headers" aria-hidden="true"></th>
                                  <th id="Status Header" class="col list-view-headers">{{convert('sellModule.manageInventory.listView.textReserveStatus')}}</th>
                                  <th id="Grounded Header" class="col list-view-headers">{{convert('sellModule.manageInventory.listView.textGrounded')}}</th>
                                  <th id="Location Header" class="col list-view-headers">{{convert('sellModule.manageInventory.listView.textLocation')}}</th>
                                  <th id="List Price Header" class="col list-view-headers">{{convert('sellModule.manageInventory.listView.textListPrice')}}</th>
                                  <th id="Miles Header" class="col list-view-headers">{{convert('sellModule.manageInventory.listView.textMiles')}}</th>
                                  <th id="Shadow Header" class="shadow-col-end list-view-headers" aria-hidden="true"></th>
                                </tr>
                              </thead>
                            }
                            <tbody>
                              @for (result of results; track trackVehicleById(i, result); let i = $index) {
                                <tr list-view-inventory-item
                                  class="list-view-inventory-item"
                                  [singleListSelected]="this.singleListSelected"
                                  [auctionItemSell]="result.auctionItem"
                                  [hadMultiOfferActionSuccess]="result.hadMultiOfferActionSuccess"
                                  [userProfile]="userProfile"
                                  data-track-region="Card"
                                  [attr.data-track-result-number]="i + 1"
                                  [attr.data-track-scroll-number]="dataTrackScrollNumber(i + 1)"
                                  [index]="i"
                                  [searchStatusFilter]="vehicleCardCommon.statusFilter"
                                  [isMobileLayout]="isMobileLayout"
                                  [isDesktop]="!isMobileLayout"
                                  [tenantName]="vehicleCardCommon.tenantName"
                                  [tenantUuid]="vehicleCardCommon.tenantUuid"
                                  [isServiceFeeVisible]="vehicleCardCommon.isServiceFeeVisible"
                                  [bsoDealer]="bsoDealer"
                                  [bsoSelected]="result.bsoSelected"
                                  [partOfBso]="result.partOfBso"
                                  [bsoMode]="result.bsoMode"
                                  [isVehicleSelected]="isVehicleToggled(result.auctionItem.auctionItemUuid)"
                                  [vehicleSelectionsEnabled]="isSellUpdateInventoryFeatureEnabled || areSellCheckboxesEnabled"
                                  [currentPage]="pagination.currentPage"
                                  [offerLists]="result.auctionItem.offerLists"
                                  [isFilterByInServiceVehicles]="isFilterByInServiceVehicles"
                                  (modalEvent)="createBanners($event)"
                                ></tr>
                              }
                            </tbody>
                          </table>
                        </div>
                      }
                      @if (isMobileLayout) {
                        @for (result of results; track trackVehicleById(i, result); let i = $index) {
                          <div list-view-inventory-item
                            class="list-view-inventory-item"
                            [singleListSelected]="this.singleListSelected"
                            [auctionItemSell]="result.auctionItem"
                            [hadMultiOfferActionSuccess]="result.hadMultiOfferActionSuccess"
                            [userProfile]="userProfile"
                            data-track-region="Card"
                            [attr.data-track-result-number]="i + 1"
                            [attr.data-track-scroll-number]="dataTrackScrollNumber(i + 1)"
                            [index]="i"
                            [searchStatusFilter]="vehicleCardCommon.statusFilter"
                            [isMobileLayout]="isMobileLayout"
                            [isDesktop]="!isMobileLayout"
                            [tenantName]="vehicleCardCommon.tenantName"
                            [tenantUuid]="vehicleCardCommon.tenantUuid"
                            [isServiceFeeVisible]="vehicleCardCommon.isServiceFeeVisible"
                            [bsoDealer]="bsoDealer"
                            [bsoSelected]="result.bsoSelected"
                            [partOfBso]="result.partOfBso"
                            [bsoMode]="result.bsoMode"
                            [isVehicleSelected]="isVehicleToggled(result.auctionItem.auctionItemUuid)"
                            [vehicleSelectionsEnabled]="isSellUpdateInventoryFeatureEnabled || areSellCheckboxesEnabled"
                            [currentPage]="pagination.currentPage"
                            [offerLists]="result.auctionItem.offerLists"
                            [isFilterByInServiceVehicles]="isFilterByInServiceVehicles"
                            (modalEvent)="createBanners($event)"
                          ></div>
                        }
                      }
                    }
                    @if (!isListView && vehicleCardCommon$ | async; as vehicleCardCommon) {
                      @for (result of results; track trackVehicleById(i, result); let i = $index) {
                        <sw-vehicle-container-hook [vehicleData]="result" class="stockwave-vehicle-row">
                          <lib-vehicle-card
                            [auctionItemSell]="result.auctionItem"
                            [userProfile]="userProfile"
                            data-track-region="Card"
                            [attr.data-track-result-number]="i + 1"
                            [attr.data-track-scroll-number]="dataTrackScrollNumber(i + 1)"
                            [index]="i"
                            [searchStatusFilter]="vehicleCardCommon.statusFilter"
                            [isMobileLayout]="vehicleCardCommon.isMobileLayout"
                            [isDesktop]="isDesktopLayout"
                            [singleListSelected]="singleListSelected"
                            [tenantName]="vehicleCardCommon.tenantName"
                            [tenantUuid]="vehicleCardCommon.tenantUuid"
                            [isServiceFeeVisible]="vehicleCardCommon.isServiceFeeVisible"
                            [bsoDealer]="bsoDealer"
                            [bsoSelected]="result.bsoSelected"
                            [partOfBso]="result.partOfBso"
                            [bsoMode]="result.bsoMode"
                            [isVehicleSelected]="isVehicleToggled(result.auctionItem.auctionItemUuid)"
                            [vehicleSelectionsEnabled]="isSellUpdateInventoryFeatureEnabled || areSellCheckboxesEnabled"
                            [sellerCommentsEnabled]="sellerCommentsEnabled"
                            [currentPage]="pagination.currentPage"
                            [offerLists]="result.auctionItem.offerLists"
                            [isFilterByInServiceVehicles]="isFilterByInServiceVehicles"
                          ></lib-vehicle-card>
                        </sw-vehicle-container-hook>
                      }
                    }
                  }
                } @else {
                  <app-error-message title="{{convert('sellModule.manageInventory.layout.labelErrorTitle')}}" subtitle="{{convert('sellModule.manageInventory.layout.labelErrorSubTitle')}}">
                  </app-error-message>
                }
              </div>
            }
          </div>
        </div>


        @if (!(searchError$ | async) && pagination && pagination.totalItems > 0) {
          <app-pagination
            [currentPage]="pagination.currentPage"
            [totalCount]="pagination.totalItems"
            [perPage]="pagination.perPage"
            [maxPages]="pagination.maxPages"
            [hidePerPage]="false"
            (pageChanged)="handleChangePage($event)"
            (perPageChanged)="handleChangePerPage($event)"
            [pagination]="transaltedObject"
          ></app-pagination>
        }
      </div>
    </div>

    <app-action-submitting-modal [actionText]="exportActionText"></app-action-submitting-modal>
    <app-action-submitted-modal
      [actionText]="exportActionSuccessText"
      [auctionSubmittedTransl]="auctionSubmittedTransl"
      (focusOnElement)="focusOnElement()">
    </app-action-submitted-modal>
    <app-error-modal></app-error-modal>
  </div>

  <ng-template #cardListViewToggleButtons>
    @if (isListViewFeatureEnabled) {
      <span class="view-toggle-buttons">
        <button
          data-track-elem="icon"
          data-track-name="card-view"
          class="btn view-btn"
          (click)="updateListViewToggle(false)"
          [disabled]="!isListView"
          >
          @if (isListView) {
            <img
              src="../../../ui/assets/assets-{{ tenantName }}/{{ tenantName }}-card-view.svg"
              alt="card view icon"
              />
          }
          @if (!isListView) {
            <img
              src="assets/icons/card-view-active.svg"
              alt="card view icon"
              />
          }
          <span>{{ convert('common.cardView') }}</span>
        </button>
        <button
          data-track-elem="icon"
          data-track-name="list-view"
          class="btn view-btn"
          (click)="updateListViewToggle(true)"
          [disabled]="isListView || (bsoMode$ | async)"
          >
          @if (!isListView) {
            <img
              src="../../../ui/assets/assets-{{ tenantName }}/{{ tenantName }}-list-view.svg"
              alt="list view icon"
              />
          }
          @if (isListView) {
            <img
              src="assets/icons/list-view-active.svg"
              alt="list view icon"
              />
          }
          <span>{{ convert('common.listView') }}</span>
        </button>
      </span>
    }
  </ng-template>

  @if (areSellCheckboxesEnabled || isSellUpdateInventoryFeatureEnabled || isSellReportingFeatureEnabled) {
    <app-action-list
      [selectedVehicles]="sellVehiclesToggled"
      [selectedVehicleStatus]="selectedVehicleStatus"
      [isSellReportingFeatureEnabled]="isSellReportingFeatureEnabled"
      [isSellUpdateInventoryFeatureEnabled]="isSellUpdateInventoryFeatureEnabled"
      [areMultipleTenantsSelected]="areMultipleTenantsSelected"
      [isSingleSharedListSelected]="singleListSelected"
      [tenantUuid]="tenantUuid"
      (onActionSelected)="showMultiActionModal($event)"
    ></app-action-list>
  }
</ng-container>
<app-shared-list-multi-action-modal [userType]="userType" (modalEvent)="completeOfferActions($event)"></app-shared-list-multi-action-modal>
